/*
 * Footer newsletter — submit without leaving the page.
 *
 * Shopify's customer form is an ordinary POST to /contact, so signing up threw
 * the shopper back to the top of a freshly loaded page and left them to work out
 * whether it had worked. This posts the same form in the background and shows
 * the answer where they are looking.
 *
 * THE SERVER STILL DECIDES. The response is Shopify's own re-render of the page,
 * and the reply shown here is lifted out of it — the same note the page would
 * have displayed after a reload. Nothing here judges whether an address is
 * valid, or invents a success message: duplicate signups, blocked domains and
 * Shopify's own validation all keep behaving exactly as they did, because the
 * verdict is still Shopify's.
 *
 * WITHOUT JAVASCRIPT the form is untouched and posts normally, and the note is
 * rendered server-side after the reload. This only ever removes a reload; it is
 * never what makes the form work.
 */
(function () {
  'use strict';

  if (window.__dwNewsletterReady) return;
  window.__dwNewsletterReady = true;

  var FORM = '.dw-footer__form';

  function noteOf(form) { return form.querySelector('[data-dw-newsletter-note]'); }

  function say(form, text, isError) {
    var note = noteOf(form);
    if (!note) return;
    note.classList.toggle('dw-footer__note--error', !!isError);
    // Cleared first so an identical repeat message still registers as a change
    // and gets announced rather than sitting there silently.
    note.textContent = '';
    note.textContent = text;
  }

  function busy(form, on) {
    var btn = form.querySelector('.dw-footer__submit');
    if (on) {
      form.setAttribute('data-dw-busy', '');
      if (btn) { btn.setAttribute('data-dw-loading', ''); btn.disabled = true; }
    } else {
      form.removeAttribute('data-dw-busy');
      if (btn) { btn.removeAttribute('data-dw-loading'); btn.disabled = false; }
    }
  }

  /* Shopify signals a successful signup by REDIRECTING to ?customer_posted=true.
     That is the reliable tell, and deliberately not "did my own note element
     appear in the response".

     The response is rendered by whichever theme is live, which is not
     necessarily the theme this script came from — on a preview theme the
     redirect drops preview_theme_id and the reply comes back as the live theme
     entirely. Parsing our own markup out of it therefore fails for reasons that
     have nothing to do with whether the shopper signed up. */
  function succeeded(res) {
    try { return (res.url || '').indexOf('customer_posted=true') > -1; }
    catch (e) { return false; }
  }

  /* Errors have no redirect, so the message has to come out of the page — and
     reading the note's class rather than the status code is what keeps them
     reading as errors: a rejected address still comes back 200. */
  function readReply(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var note = doc.querySelector('[data-dw-newsletter-note]');
    if (!note) return null;
    var text = (note.textContent || '').replace(/\s+/g, ' ').trim();
    if (!text) return null;
    return { text: text, isError: note.classList.contains('dw-footer__note--error') };
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches(FORM)) return;
    if (form.hasAttribute('data-dw-busy')) { e.preventDefault(); return; }

    // Let the browser's own required/type=email check run first, and fall back
    // to a normal post if anything here is unavailable.
    if (!window.fetch || !window.FormData || !window.DOMParser) return;

    e.preventDefault();
    busy(form, true);
    say(form, '', false);

    var field = form.querySelector('.dw-footer__input');

    fetch(form.action, {
      method: 'POST',
      body: new FormData(form),
      credentials: 'same-origin',
      headers: { 'Accept': 'text/html' }
    })
      .then(function (r) {
        var info = { posted: succeeded(r), ok: r.ok, status: r.status };
        return r.text().then(function (html) { info.html = html; return info; });
      })
      .then(function (res) {
        var wrap = form.closest('[data-dw-error]');

        if (res.posted) {
          say(form, (wrap && wrap.getAttribute('data-dw-success')) || 'Thanks — you are on the list.', false);
          if (field) field.value = '';
          return;
        }

        /*
         * Shopify did not accept the request at all. In practice this is its bot
         * challenge — a 403 titled "Verifying your connection" — which has to be
         * resolved by a real navigation, not by a background fetch.
         *
         * Hand it back to the browser rather than inventing a verdict. Calling
         * this a validation error would tell someone with a perfectly good
         * address that it is invalid, which is exactly the wrong answer and one
         * they cannot argue with. The native post shows the challenge, they
         * clear it, and the signup completes just as it did before this file
         * existed: a page reload, which is the behaviour being improved on, not
         * a regression.
         */
        if (!res.ok) {
          form.removeAttribute('data-dw-busy');
          form.submit();
          return;
        }

        // 200 with no redirect: a genuine rejection. Prefer Shopify's wording.
        var reply = readReply(res.html);
        say(form,
            (reply && reply.text) || (wrap && wrap.getAttribute('data-dw-invalid')) || 'Please enter a valid email address.',
            true);
      })
      .catch(function () {
        busy(form, false);
        var wrap = form.closest('[data-dw-error]');
        say(form, (wrap && wrap.getAttribute('data-dw-error')) || 'Something went wrong. Please try again.', true);
      })
      .then(function () {
        if (form.hasAttribute('data-dw-busy')) busy(form, false);
      });
  });
})();
